import { AxiosResponse } from 'axios';
import { axiosRequest } from './../../axios/axios.config';
import LoginService from "pages/login/login.service";
import { FiltroAvancadoContaReceberDTO, FlowBaixaContaReceberDTO, FlowContaBaixaDTO, FlowContaReceberDTO, FlowContaReceberExclusaoDTO, FlowContaReceberVisualizacaoDTO } from './financas.model';
import { TAcenumDTO } from 'pages/Configuracoes/ConfigurarMovimentacaoFiscal';
import { GenericTO } from 'model/generic.model';
import { ValidateNsuNumControleDTO } from 'pages/pagamento/pagamento.model';

const FinancasService = () => {
    const path = '/conta/receber';
    const loginService = LoginService();

    return {
        getContasReceber(filtro: FiltroAvancadoContaReceberDTO): Promise<AxiosResponse<Array<FlowContaReceberDTO>>> {
            return axiosRequest.post(`${path}/lista-por-empresa`, filtro, { headers: loginService.getHeaders() });
        },
        getVisualizarContasReceber(uuid: string): Promise<AxiosResponse<FlowContaReceberVisualizacaoDTO>> {
            return axiosRequest.get(`${path}/visualizar/${uuid}`, { headers: loginService.getHeaders() })
        },
        getContasBaixar(uuidsContaReceber: Array<string>): Promise<AxiosResponse<Array<FlowContaBaixaDTO>>> {
            return axiosRequest.post(`${path}/listar-baixas`, uuidsContaReceber, { headers: loginService.getHeaders() })
        },
        baixarContasReceber(baixar: FlowBaixaContaReceberDTO): Promise<AxiosResponse<Array<FlowContaReceberDTO>>> {
            return axiosRequest.put(`${path}/baixar-contas-receber`, baixar, { headers: loginService.getHeaders() })
        },
        getSituacoesChequeRecebido(): Promise<AxiosResponse<Array<TAcenumDTO>>> {
            return axiosRequest.get(`${path}/acenum/SituacaoChequeRecebido`, { headers: loginService.getHeaders() })
        },
        countContasReceber(filtro: FiltroAvancadoContaReceberDTO): Promise<AxiosResponse<number>> {
            return axiosRequest.post(`${path}/count-lista-por-empresa`, filtro, { headers: loginService.getHeaders() });
        },
        listarContasFinanceiras(): Promise<AxiosResponse<Array<GenericTO>>> {
            return axiosRequest.get(`/contafinanceira/listar-caixas`, { headers: loginService.getHeaders() })
        },
        listarExclusao(uuid: string): Promise<AxiosResponse<FlowContaReceberExclusaoDTO>> {
            return axiosRequest.get(`${path}/listar-exclusao/${uuid}`, { headers: loginService.getHeaders() })
        },
        excluirBaixa(uuidContaReceber: string, baixaUUIDS: Array<string>): Promise<AxiosResponse<FlowContaReceberDTO>> {
            return axiosRequest.put(`${path}/excluir-baixa/${uuidContaReceber}`, baixaUUIDS, { headers: loginService.getHeaders() })
        },
        validateNsuNumControle(validate: ValidateNsuNumControleDTO): Promise<AxiosResponse<ValidateNsuNumControleDTO | null>> {
            return axiosRequest.post(`${path}/validate-nsu-num-controle`, validate, { headers: loginService.getHeaders() })
        },
        validaApuracoes(uuid: string): Promise<AxiosResponse<boolean>> {
            return axiosRequest.get(`${path}/valida-apuracao/${uuid}`, { headers: loginService.getHeaders() })
        }
    };
};

export default FinancasService;

